import { reactive } from 'vue';

export const chartStore = reactive({
  bodyToSendToApi: null,
});
